"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMemberOfTheEuropeanUnion = exports.europeanCountries = void 0;
/** A list of all countries codes that are part of the European Union */
exports.europeanCountries = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
];
/**
 * Return true if the country is a member of the European Union.
 */
var isMemberOfTheEuropeanUnion = function (countryCode) {
    return Boolean(countryCode) && exports.europeanCountries.includes(countryCode);
};
exports.isMemberOfTheEuropeanUnion = isMemberOfTheEuropeanUnion;
//# sourceMappingURL=european-countries.js.map